exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-row {\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #fff;\n  cursor: pointer;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);\n  margin-bottom: 5px; }\n\n.container-logo {\n  width: 30%;\n  margin-right: 10px; }\n\n.container-logo img {\n  width: 60%;\n  margin-left: 20px; }\n\n.content-elements {\n  width: 100%; }\n\n.fab-icon i {\n  font-size: 20px;\n  margin-left: 65%;\n  margin-top: 12px; }\n\n.fab-android {\n  color: #a4c639; }\n\n.fab-apple {\n  color: gray; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/device-information/device-information/device-information.component.scss
// module id = 1898
// module chunks = 66